import React, { useContext, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import launcherIcon from 'icons/neva_launcher.png'
import { WebSocketsSharedContext } from 'integrations/WebSockets'
import { sendOpenedGreeting } from 'api/api'
import widgetStorage from 'actions/storage'
import { CountUnreadMessagesContext } from 'context/CountUnreadMessagesContext'
import { EndConversationModalContext } from 'context/EndConversationContext'
import { UnreadMessagesContext } from 'context/UnreadMessagesContext'

import { UnreadMessagesCounter } from '../UnreadMessagesCounter'

import { ButtonLauncherContainer, LauncherImage } from './Button.style'

const Button = ({
  isWidgetOpened,
  toggleWidget,
  greeting,
  authorized,
  botId,
  isHiddenWidget,
  handleViewWidget
}) => {
  // @ts-ignore
  //TODO: @Igor Ukhin change WebSockets.js to ts
  const { initializeConversation } = useContext(WebSocketsSharedContext)
  const { unreadMessages } = useContext(CountUnreadMessagesContext)

  const { setIsOpenEndConversationModal } = useContext(EndConversationModalContext)
  const { isWidgetPopup } = useContext(UnreadMessagesContext)
  const buttonLauncherRef = useRef(null)
  const { t } = useTranslation()

  useEffect(() => {
    buttonLauncherRef.current.focus()
  }, [])

  const handleToggleWidget = (): void => {
    const chatId = widgetStorage.tryFindChatIdInAnyStorage()

    if (isWidgetPopup && greeting) {
      sendOpenedGreeting(botId, greeting.hash, chatId)
      if (greeting.payload && authorized) {
        const message = {
          type: 'postback',
          payload: greeting.payload,
          isRtl: false
        }
        initializeConversation(message)
      }
    }

    if (isHiddenWidget) {
      handleViewWidget()
      return
    }

    if (!chatId) {
      toggleWidget()
      return
    }

    if (!isWidgetOpened) {
      setIsOpenEndConversationModal(true)
      return
    }

    if (isWidgetOpened) {
      toggleWidget()
    }
  }

  return (
    <ButtonLauncherContainer
      ref={buttonLauncherRef}
      onClick={handleToggleWidget}
      id="widget-button"
    >
      <LauncherImage
        src={launcherIcon}
        alt={t('avatar')}
      />
      {isHiddenWidget && !!unreadMessages && <UnreadMessagesCounter />}
    </ButtonLauncherContainer>
  )
}

export default Button
